import React from 'react'
import Pagination from "react-js-pagination";

import Border from '../Border'

import Section from './editable/Section'


import General from '../../utils/General'
import Titles from "./editable/Titles";
import Collapsible from "react-collapsible";
import DataParser from "../../utils/DataParser";
import FileUploader from "../common/FileUploader";

import Block from "./Block";

export default class Block58 extends Block {
  constructor(props){
    super(props)

    this.state = {
      key: 0,
      data: props.data,
      editable: props.editable,
      pageCount: 1,
      uuid: "cb_"+General.uuid()
    }

    this.section = React.createRef();

  }

  componentDidMount() {
    this._parseFile()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps, () => this._parseFile())
  }

  _update(data, callback){
    let {
      key
    } = this.state

    this.setState({ ...data }, () => {

      if(callback){
        callback()
      }
      this.updateContentBlock()
    })
  }

  _parseFile(){
    let {
      data,
      pageCount
    } = this.state

    let paginatedData = []

    if(data.extra?.file){
      let fileUrl = data.extra.file.url
      fetch(fileUrl).then(response => {
        return response.arrayBuffer()
      }).then((ab) => {
        let fileData = new Uint8Array(ab)
        let [headers, movieData] = DataParser.formatData(fileData, fileUrl)
        if(data.extra.page_size === "all"){
          paginatedData = movieData
        }else{
          paginatedData = DataParser.paginateData(movieData, data.extra.page_size, 1)
        }
        this.setState({headers, movieData, paginatedData, pageCount: 1})
      })

    }

  }

  _renderModalContent(data) {

    let className = "field-file "
    className += data.is_required ? "validate-required" : ""
    if(data.error){
      className += " validation-error"
    }

    return (
      <>
        <Border>
          <Collapsible trigger="Data File">
            <br></br>
            <div className={className}>
              <div className="row">
                <div className="col-md-12">
                  Please <a
                  href="javascript:void(0)"
                    className="cursor-pointer"
                    onClick={() => {
                      window.open('/assets/template/Template File.xlsx', '_blank')
                    }}
                  >
                    download the template file
                  </a>, fill in all available columns and upload below.
                </div>
              </div>
              <br/>
              <FileUploader
                key={data.extra?.file?.id}
                placeholder={"Upload Data File (.xlsx)"}
                endpoint={window.Api.Files}
                params={{website_id: window.CURRENT_WEBSITE_ID}}
                accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onUploading={() => {
                  this.setState({loading: true})
                }}
                onUploaded={file => {
                  let value = {file: file};
                  data.error = false
                  data.extra = value
                  this.setState({data}, () => {
                    this._parseFile()
                    this._update(data)
                  })
                }}
                onRemoved={() => {
                  data.extra.file = null
                  this.setState({data}, () => {
                    this._parseFile()
                    this._update(data)
                  })
                }}
              />
            </div>
          </Collapsible>
        </Border>

        <Border>
          <Collapsible trigger="Layout">
            <br></br>
            <div># of Items Per Page</div>
            <select
              value={data.extra?.page_size || "4"}
              onChange={(event) => {
                data.extra.page_size = event.target.value;
                this._update(data);
                this._parseFile();
              }}
            >
              <option value="4">4 Items</option>
              <option value="5">5 Items</option>
              <option value="8">8 Items</option>
              <option value="10">10 Items</option>
              <option value="16">16 Items</option>
              <option value="20">20 Items</option>
              <option value="all">All Items</option>
            </select>
            <br/><br/>
            <div># Of Columns On Desktop</div>
            <select
              value={data.extra?.columns || "4"}
              onChange={(event) => {
                data.extra.columns = event.target.value;
                this._update(data);
                this._parseFile();
              }}
            >
              <option value="5">5 Columns</option>
              <option value="4">4 Columns</option>
              <option value="3">3 Columns</option>
              <option value="2">2 Columns</option>
            </select>
            <br/><br/>
            <div># Of Columns On Mobile</div>
            <select
              value={data.extra?.mobile_columns || "3"}
              onChange={(event) => {
                data.extra.mobile_columns = event.target.value;
                this._update(data);
              }}
            >
              <option value="4">4 Columns</option>
              <option value="3">3 Columns</option>
              <option value="2">2 Columns</option>
            </select>
          </Collapsible>
        </Border>
      </>
    );
  }

  _renderBlockStyle(){
    let {
      data
    } = this.state

    return (
      <style dangerouslySetInnerHTML={{__html: `
        #${data.anchor}.block-58 .item a span {
          color: ${data.settings.quaternary_color} !important;
          background-color: ${data.settings.quinary_color} !important;
        }
        .react-js-pagination li a {
          color: ${data.settings.quinary_color};
        }
        .react-js-pagination li a {
          color: ${data.settings.quinary_color};
        }
        .react-js-pagination .page-item.active {
          border-color: ${data.settings.quinary_color};
        }
      `}}/>
    )
  }

  render(){
    let { data, editable, uuid, key, pageCount, movieData, paginatedData } = this.state
    let rowColumnsCss = data.extra?.columns
    if(!rowColumnsCss){
      rowColumnsCss = 4
    }
    let rowMobileColumnsCss = data.extra?.mobile_columns
    if(!rowMobileColumnsCss){
      rowMobileColumnsCss = 3
    }

    return (
      <>
        <Section
          data={ data }
          index={ this.props.index }
          className={ " block-58 text-center " + this.props.className }
          editable={ editable }
          renderModalContent={() => this._renderModalContent(data)}
          onUpdated={data => this._update(data)}
          primaryColor={false}
          secondaryColor={false}
          quaternaryColorTitle="Overlay Text Color"
          quinaryColorTitle="Overlay Background Color"
          onDelete={() => this.props.onDelete()}
          onAddContentBlockPressed={contentBlock => this.props.onAddContentBlockPressed(contentBlock)}
          canMoveUp={ this.props.canMoveUp }
          canMoveDown={ this.props.canMoveDown }
          onVisibilityButtonPressed={(index) => this.props.onVisibilityButtonPressed(index)}
          onMoveUpPressed={ () => this.props.onMoveUpPressed() }
          onMoveDownPressed={ () => this.props.onMoveDownPressed() }
          onVisibilityToggled={() => this.props.onVisibilityToggled()}
        >
          <div className="container">

            <Titles
              data={ data }
              editable={ editable }
              headingNumber={2}
              onUpdated={data => this._update(data)}
            />

            <div
              className={`row row-cols-${rowMobileColumnsCss} row-cols-md-${rowColumnsCss}`}
            >
              {
                paginatedData && paginatedData.map(item => {
                  let columns = data.extra?.columns || "4"
                  let className = "col-3"
                  if(columns === "3"){
                    className = "col-4"
                  }else if(columns === "2"){
                    className = "col-6"
                  }
                  return (
                    <>
                      <div className="col item">
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            if(item.link) {
                              window.open(item.link, '_self')
                            }
                          }}
                        >
                          <img
                            key={item.image}
                            src={item.image}
                            alt=""
                            loading="lazy"
                            className='shimmer'
                          />
                          <span>
                            <i className='name'>{item.name}</i>
                            {item.year && <small className="m_t">Year: {item.year}</small>}
                            {item.cast && <small>Cast: {item.cast}</small>}
                            {item.genre && <small>Genre: {item.genre}</small>}
                          </span>
                        </a>
                      </div>
                    </>
                  )
                })
              }
            </div>
            {
              ((movieData?.length > paginatedData?.length) && (data.extra?.page_size !== "all" && movieData)) &&
              <>
                <div className="row mt-5">
                  <Pagination
                    activePage={parseInt(pageCount)}
                    itemsCountPerPage={data.extra?.page_size || 4}
                    totalItemsCount={movieData.length}
                    pageRangeDisplayed={5}
                    hideFirstLastPages={true}
                    hideDisabled={true}
                    innerClass={"pagination react-js-pagination"}
                    itemClass={"page-item"}
                    linkClass={"page-link"}
                    activeClass={"active"}
                    onChange={(page) => {
                      let newData = DataParser.paginateData(movieData, data.extra.page_size, page)
                      this.setState({
                        paginatedData: newData,
                        pageCount: page
                      })
                    }}
                  />
                </div>
              </>
            }
          </div>
        </Section>
        {this._renderBlockStyle()}
      </>
    )
  }
}
